<template>
    <div class="wrap-content advance-search">
        <div class="filter-section">
            <h2>Advance Search</h2>
        </div>
        <div class="card">
            <b-form v-if="show" @submit.stop.prevent="onSubmit">
                <div class="row">
                    <div
                        v-for="field in advanceSearchFields.idenfoEngine"
                        :key="field.key"
                        class="col-md-4"
                    >
                        <component
                            :is="field.type"
                            v-if="dataSegmentId"
                            :field="field"
                            :data-segment-id="dataSegmentId"
                        ></component>
                    </div>
                    <div class="col-md-12 seprator-line"><hr /></div>
                    <div
                        v-for="field in advanceSearchFields.kyc"
                        :key="field.key"
                        class="col-md-4"
                    >
                        <component
                            :is="field.type"
                            v-if="dataSegmentId"
                            :field="field"
                            :data-segment-id="dataSegmentId"
                        ></component>
                    </div>
                    <div class="col-md-4 form-radio reg-channel">
                        <b-form-group
                            id="input-group-12"
                            label="Registration Channel"
                            label-for="channel"
                        >
                            <b-form-group>
                                <b-form-radio-group
                                    v-model="
                                        formData[
                                            'accountInfo.registrationChannelId'
                                        ]
                                    "
                                    :options="options"
                                    name="channel"
                                ></b-form-radio-group>
                            </b-form-group>
                        </b-form-group>
                    </div>
                    <div class="col-md-12 seprator-line"><hr /></div>
                    <div class="col-md-12">
                        <base-button
                            btn-label="Search now"
                            btn-type="submit"
                            btn-variant="primary"
                            :class="loading ? 'disabled' : ''"
                            :disabled="loading"
                        ></base-button>
                    </div>
                </div>
            </b-form>
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

import request from '@/utils/request'
import Heading from '@/components/registration/Heading.vue'
import TextField from '@/components/registration/TextField.vue'
import List from '@/components/registration/List.vue'
import Dropdown from '@/components/registration/Dropdown.vue'
import Radio from '@/components/registration/Radio.vue'

export default {
    components: {
        Heading,
        TextField,
        List,
        Dropdown,
        Radio,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            show: true,
            options: [
                {
                    text: 'All',
                    value: null,
                },
            ],
            formData: {
                'basicInfo.firstName': '',
                'basicInfo.middleName': '',
                'basicInfo.lastName': '',
                'basicInfo.genderId': null,
                'basicInfo.nationalityId': null,
                'basicInfo.countryOfResidenceId': null,
                'occupationInfo.workTypeId': null,
                'occupationInfo.industryId': null,
                status: null,
                'kycSummary.nameScreening': null,
                'kycSummary.riskRating': null,
                'identityInfo.type': null,
                'accountInfo.products.productId': null,
                'accountInfo.registrationChannelId': null,
            },
        }
    }, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getRegistrationChannels()
            }
        },
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapState({
            formFields: (state) => state.registration.form,
        }),
        ...mapGetters(['loading', 'dataSegmentId', 'advanceSearchFields']),
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        let page = this.$store.getters.getField('pagination')
        this.getRegistrationChannels()
        /*** this line resets the advance seach form fields ***/
        this.$store.commit('initDefaultFields', 'form')
        this.$store.commit('updateField', {
            key: 'pagination',
            value: page,
        })
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async onSubmit() {
            // validate the form fields
            const result = await this.$validator.validateAll()

            // Check if validation fails
            if (result) {
                this.formData['basicInfo.firstName'] =
                    this.formFields.basicInfo.firstName
                this.formData['basicInfo.middleName'] =
                    this.formFields.basicInfo.middleName
                this.formData['basicInfo.lastName'] =
                    this.formFields.basicInfo.lastName
                this.formData['basicInfo.genderId'] =
                    this.formFields.basicInfo.genderId
                this.formData['basicInfo.countryOfResidenceId'] =
                    this.formFields.basicInfo.countryOfResidenceId
                this.formData['basicInfo.nationalityId'] =
                    this.formFields.basicInfo.nationalityId
                this.formData['occupationInfo.workTypeId'] =
                    this.formFields.occupationInfo.workTypeId
                this.formData['occupationInfo.industryId'] =
                    this.formFields.occupationInfo.industryId
                this.formData.status = this.formFields.customInfo.status
                    ? this.formFields.customInfo.status.value
                    : ''
                this.formData['kycSummary.nameScreening'] = this.formFields
                    .customInfo.nameScreening
                    ? this.formFields.customInfo.nameScreening.value
                    : ''
                this.formData['kycSummary.riskRating'] = this.formFields
                    .customInfo.riskRating
                    ? this.formFields.customInfo.riskRating.value
                    : ''
                this.formData['identityInfo.type'] = this.formFields.customInfo
                    .type
                    ? this.formFields.customInfo.type.value
                    : ''
                this.formData['accountInfo.products.productId'] = this
                    .formFields.customInfo.productId
                    ? this.formFields.customInfo.productId.value
                    : null
                localStorage.setItem('queryData', JSON.stringify(this.formData))
                this.$store.commit('setLoading', true)
                this.$router.push({
                    name: 'view-customer-profile',
                })
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method
        async getRegistrationChannels() {
            let dataSegmentId = localStorage.getItem('dataSegmentId')
            if (this.dataSegmentId) {
                dataSegmentId = this.dataSegmentId
            }
            try {
                // fetch the list of associated configurations
                let { data } = await request({
                    url: `/configurations/channel-types`,
                    params: {
                        dataSegmentId: dataSegmentId,
                        perPage: 1000,
                        ref: 'dropdown',
                    },
                })
                // update the local list of options
                let self = this
                self.options = [
                    {
                        text: 'All',
                        value: null,
                    },
                ]
                data.data.forEach(function (val) {
                    self.options.push({
                        text: val.title,
                        value: val._id,
                    })
                })
            } catch (error) {
                console.log(error)
            }
        },
    }, // End of Component > mounted
} // End of export default
</script>
